import React, { useState ,useEffect,useRef } from 'react'
import { Link } from 'react-router-dom'
import Skeleton from '../skelton'





const GallerySection = ({format,catLink,formatData,mobile}) => {

               const [data,setData] = useState(formatData)
               const [loading,setLoading] = useState(false)
               const [hydrating,setHydrating] = useState(format === 'Actress' ? true : false)
               const [error,setError]= useState(null)
               const isFirstLoad = useRef(true);

   useEffect(()  =>   {
    
          const hydrationTimer = setTimeout(() => {
             
                setHydrating(false)
   
          },300);
   
   
          return () => clearTimeout(hydrationTimer);
   
      },[])



   useEffect(() =>  {

        if (format === 'Actress')  {

                 if (data && isFirstLoad.current) {
                        isFirstLoad.current = false;
                         return;
                    }
                     setLoading(true)
                
                    const fetchData = async () => {
                    try {
                    const res = await fetch("https://teluguone.com/photos_api/photosLatestByTypeJson?galTypeId=1&start=0&limit=6");
                    if (!res.ok) throw new Error(`API Response Was Not Ok`)
                    const data = await res.json();
                    setData(data.photosHomeByType || '');
                
                  } catch (e) {
                    console.error("Fetch error:", e);
                    setError(e.message)
                   }finally {
                    setLoading(false)
                  }
                };

                fetchData(); 

             
        }
        else if (format === 'Events') {
                   if (data && isFirstLoad.current) {
                        isFirstLoad.current = false;
                         return;
                    }
                     setLoading(true)
                
                    const fetchData = async () => {
                    try {
                    const res = await fetch("https://teluguone.com/photos_api/photosLatestByTypeJson?galTypeId=10&start=0&limit=6");
                    if (!res.ok) throw new Error(`API Response Was Not Ok`)
                    const data = await res.json();
                    setData(data.photosHomeByType || '');
                
                  } catch (e) {
                    console.error("Fetch error:", e);
                    setError(e.message)
                   }finally {
                    setLoading(false)
                  }
                };

                fetchData(); 
        }
         else {

                 if (data && isFirstLoad.current) {
                        isFirstLoad.current = false;
                         return;
                    }
                     setLoading(true)
                
                    const fetchData = async () => {
                    try {
                    const res = await fetch(`https://teluguone.com/photos_api/photosLatestByTypeJson?galTypeId=9&start=0&limit=${mobile ? 4 : 6}`);
                    if (!res.ok) throw new Error(`API Response Was Not Ok`)
                    const data = await res.json();
                
                    setData(data.photosHomeByType || '');
                
                  } catch (e) {
                    console.error("Fetch error:", e);
                    setError(e.message)
                   }finally {
                    setLoading(false)
                  }
                };

                fetchData(); 

         }

   }, [format])

   
    



  return (
   
   
        <section className="gallery-section">
               <div className="section-header">
                 <h2 className="section-title"><Link to={catLink} >{format}</Link></h2>
                 <Link to={catLink} className="see-all">View All →</Link>
              </div>
               

             
              
              {format === 'Actress'  && <div className="gallery-grid">
                        
                        {
                            (loading || hydrating || error) && <> <div className="gallery-card featured-card">
                                        <Link to="">
                                            <Skeleton type="feature-card-img" /> 
                                            <div className="card-info">
                                            <h3>Actress</h3>
                                            <span className="card-link">See More →</span>
                                            </div>
                                        </Link>
                                      </div>
                                       <div className="gallery-side-list">
                                        {[0,0,0,0].map((item,index) => <Link key={index} to="" className="side-item">
                                            <Skeleton type="side-item-img" />
                                            <div className="side-info">
                                            <h4>Actress</h4>
                                            <span>See More...</span>
                                            </div>
                                        </Link>)}
                                  
                                 </div>
                              </>
                            }
                           {data && <div className={`gallery-card featured-card ${hydrating ? 'd-none' : ''}`}>
                               <Link to={(data?.[1]?.url_link  ? data?.[1]?.url_link.substring(data?.[1]?.url_link.indexOf('/photos')+7) :""  )}>
                                    <img src={data?.[1]?.stimg || ''} alt={data?.[1]?.title || ''} loading="lazy" />
                                    <div className="card-info">
                                         <h3>{data?.[1]?.title || ''}</h3>
                                         <span className="card-link">See More →</span>
                                     </div>
                                </Link>
                           </div>}

                           {data && <div className={`gallery-side-list ${hydrating ? 'd-none' : ''}`}>
                           
                             {data.slice(2,mobile ? 5 :6)?.map((item,index) => <Link key={index} to={(item.url_link  ? item.url_link.substring(item.url_link.indexOf('/photos')+7) :""  )} className="side-item">
                                <img src={item.stimg || ''} alt={item.title || ''} loading="lazy" />
                                <div className="side-info">
                                <h4>{item.title || ''}</h4>
                                <span>See More...</span>
                                </div>
                            </Link>)
                             }
             
                            </div>}
              </div>
              }


              { format === 'Events'  && <div className="events-grid">
              
                {(loading  || error) &&
                   [0,0,0,0].map((item,index) =>  
                    
                      <Link key={index} to="" className="event-card">
                         <Skeleton type="events-grid-img" /> 
                   <div className="event-info">
                  <span className="event-tag"></span>
                  <h4>Event</h4>
                </div>
                </Link>
                   
                   
                   )
                  
                
                  } 
                
                
                 {data && data.slice(1,5)?.map((item,index) => <Link key={index} to={(item.url_link  ? item.url_link.substring(item.url_link.indexOf('/photos')+7) :""  )} className="event-card">
                  <img src={item.stimg || ''} alt={item.title || ''} loading="lazy" />
                   <div className="event-info">
                  <span className="event-tag">Event</span>
                  <h4>{item.title || ''}</h4>
                </div>
                </Link>)}

          
                </div>
              }



              { format === 'Wallpapers' &&  <div className="wallpaper-grid">
                    
                     {(loading || error) &&
                   [0,0,0,0,0,0].map((item,index) =>  
                    
                      <Link key={index} to="" className="wp-card">
                         <Skeleton type="wp-card-img" /> 
                        <div className="wp-overlay"><span>View wallpaper</span></div>
                   </Link>

                   )
                  
                
                  } 
                   
                   {data && data.map((item,index) => <Link key={index} to={(item.url_link  ? item.url_link.substring(item.url_link.indexOf('/photos')+7) :""  )} className="wp-card">
                     <img src={item.stimg || ''} alt="Wallpaper" loading="lazy" />
                     <div className="wp-overlay"><span>View wallpaper</span></div>
                   </Link> ) }
          
                 </div>
              }


              


        </section>
      
      
  )




}

export default GallerySection
